import { render, staticRenderFns } from "./PersonalCertificate.vue?vue&type=template&id=70804c3b&scoped=true&"
import script from "./PersonalCertificate.vue?vue&type=script&lang=js&"
export * from "./PersonalCertificate.vue?vue&type=script&lang=js&"
import style0 from "./PersonalCertificate.vue?vue&type=style&index=0&id=70804c3b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70804c3b",
  null
  
)

export default component.exports